import { PublicUserResponse } from "@authory-packages/core";

// Ships disabled. Set to true to answer every public page of a flagged account with a 404.
const ENFORCE_SPAM_404 = true;

/**
 * Whether an account's public pages are hidden because it is flagged as spam
 * @param user The public user of the requested page
 * @returns True when hiding is enforced and the user is flagged as spam
 */
export function isHiddenAsSpam(user: PublicUserResponse): boolean {
    return ENFORCE_SPAM_404 && user.flaggedAsSpam;
}
